import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import { SharedModule } from '../shared/shared.module';
import { AppsModule } from '../apps/apps.module';
import { NgIconsModule } from '@ng-icons/core';
import { heroBell, heroChatBubbleLeftRight, heroChartBar, heroClipboard, heroCreditCard, heroCursorArrowRays, heroDevicePhoneMobile, heroExclamationTriangle, heroFolderOpen, heroPaperAirplane, heroPhoneArrowUpRight, heroQueueList, heroTrash, heroUser, heroCheckCircle, heroArrowsRightLeft, heroUsers, heroPlus, heroInformationCircle, heroPlusCircle, heroBuildingStorefront, heroSparkles, heroNoSymbol, heroShieldCheck, heroCheckBadge, heroTag, heroWallet } from '@ng-icons/heroicons/outline';
import { BillingComponent } from './billing/billing.component';
import { BillingDateFormatPipe } from './billing/billing-date-format.pipe';
import { BillingPriceFormatPipe } from './billing/billing-price-format.pipe';

import { NotificationsComponent } from './notifications/notifications.component';
import { ProfileComponent } from './profile/profile.component';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import { UsersComponent } from './users/users.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { heroCheckBadgeSolid, heroCreditCardSolid, heroEyeSolid, heroInformationCircleSolid, heroMapPinSolid, heroSparklesSolid, heroTagSolid, heroUserSolid } from '@ng-icons/heroicons/solid';


@NgModule({
  declarations: [AccountComponent, BillingComponent, BillingDateFormatPipe, BillingPriceFormatPipe, NotificationsComponent, ProfileComponent, UsersComponent, CreateAccountComponent],
  imports: [
    CommonModule,
    AccountRoutingModule,
    SharedModule,
    AppsModule,
    NgbProgressbar,
    NgIconsModule.withIcons({
      heroTrash, heroCheckBadgeSolid, heroEyeSolid, heroShieldCheck, heroUser, heroClipboard, heroBell, heroCreditCard, heroChartBar, heroFolderOpen, heroDevicePhoneMobile, heroPaperAirplane, heroCheckCircle, heroArrowsRightLeft, heroUsers, heroPlus, heroInformationCircle, heroInformationCircleSolid, heroPlusCircle, heroBuildingStorefront, heroSparklesSolid, heroMapPinSolid, heroUserSolid, heroCreditCardSolid, heroNoSymbol, heroTagSolid, heroCursorArrowRays, heroPhoneArrowUpRight, heroChatBubbleLeftRight, heroExclamationTriangle, heroSparkles, heroWallet, heroQueueList
    }),
  ],
  providers: [],
  exports: []
})
export class AccountModule {
}
